import { Component, Input, OnInit, OnChanges, Output, NgZone, ElementRef, ViewChild } from '@angular/core';
import { PopupComponent } from '../common/utilities/popup/popup.component';
// import { LoginService } from './login.service';
// import { Response } from '@angular/http';
// import { RouteContextProvider } from './../services/routeContextProvider.service';
@Component({
    // tslint:disable-next-line:component-selector
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
    /*   providers: [LoginService, RouteContextProvider, TemplateLoaderService] */
})
export class LoginComponent implements OnInit {
    public IsResume: boolean;
    public IsOverlay: boolean;
    public Config = { show: false, backdrop: 'static' };
    @Output() public ResumeApplObj;
    /* popup */
    @ViewChild(PopupComponent, { static: false }) public PopupComponent;
    /*  constructor(private _loanProgressService: LoanProgressService) { } */
    public ngOnInit() {
        console.log('Progress State');
    }
    public OpenPopup(event) {
        this.Config.show = true;
        this.PopupComponent.ShowModalDialog(event);
    }
    public ClosePopup(event) {
        this.PopupComponent.HideModalDialog(event);
    }
}
